import { useMsal } from '@azure/msal-react';
import { Text } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useStores } from '../../common/hooks';
import { ProgramDocument } from '../../models';
import { getCardThemeTypeByIndex, PageTitle, ProgramDocumentCard } from '../shared-components';
import { FlexBox } from '../shared-components/flex-box';
import Loading from '../shared-components/Loading';
import './JudgingResourcesPage.scss';

const JudgingResourcesPageImpl: React.FC = () => {
  const {
    instance
  } = useMsal();

  const {
    apiStore,
    judgingResourcesPageUiStore,
  } = useStores();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const renderProgramDocuments = (programDocuments: ProgramDocument[]) => {
    return (
      <FlexBox
        wrap
        as='section'
        content={programDocuments.length ? 'start' : 'center'}
        className='judging-resources-page__cards'
      >
        {
          !!programDocuments.length ? programDocuments.map((programDocument, index) => (
            <ProgramDocumentCard
              key={programDocument.programDocumentId}
              programDocument={programDocument}
              cardTheme={getCardThemeTypeByIndex(index)}
            />
          )) : <Text>No resource found</Text>
        }
      </FlexBox>
    );
  };

  const getProgramDocuments = async () => {
    try {
      const judgingProgramDocuments = await apiStore.getProgramDocuments(instance, {
        type: 'judging-resource'
      });
      judgingResourcesPageUiStore.setProgramDocuments('judging-resource', judgingProgramDocuments);
    } catch (error) {
      // TODO: Handle error
    }
  }

  const preloadData = async () => {
    setIsLoading(true);

    await Promise.allSettled([
      getProgramDocuments(),
    ]);

    setIsLoading(false);
  }

  useEffect(() => {
    preloadData();
    return () => {
      judgingResourcesPageUiStore.resetStates();
    }
  }, []);

  return (
    <main
      className='judging-resources-page'
    >
      {isLoading && <Loading />}
      <PageTitle
        title='Judging Resources'
        subtitle='Microsoft AI Cloud Partner Program'
      />
      {renderProgramDocuments(judgingResourcesPageUiStore.getProgramDocuments('judging-resource'))}
    </main>
  );
};

export const JudgingResourcesPage = observer(JudgingResourcesPageImpl);
